import { render } from "./RefundsComponent.vue?vue&type=template&id=b334097e"
import script from "./RefundsComponent.vue?vue&type=script&lang=js"
export * from "./RefundsComponent.vue?vue&type=script&lang=js"

import "./RefundsComponent.vue?vue&type=style&index=0&id=b334097e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__